import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import Button from 'aria-viewer/tour/components/buttons/button'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'
import Icon from 'aria-viewer/tour/components/icon'
import { MAIN_ACCESS_BUTTON_INDEX } from 'aria-viewer/keyboard/constants/tabIndices'
import { launchAccessibilityExperience } from 'aria-viewer/tour/tourActions'
import { KEY_CODES } from 'aria-viewer/tour/constants/index'

class AccessibleButton extends PureComponent {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <Button
                className={this.props.className || ''}
                style={this.props.style}
                tabIndex={MAIN_ACCESS_BUTTON_INDEX}
                id="accessible_version"
                onClick={this.props.launchAccessibilityExperience}
                altRespectCase="open accessible version"
                alt="open accessible version"
                icon="accessible"
                svgStyle={this.props.iconStyle}
                keyboard={KEY_CODES.A}
                keyboardAlt={true}
                {...this.props}
            >
                {this.props.children}
            </Button>
        )
    }
}

export default connect(
    mapSelectorsToProps(['loading']),
    { launchAccessibilityExperience }
)(AccessibleButton)
